var unitPrice = "{{ pricePerUnit }} ciascuno";
var unitsCount = "{{ unitsCount }} unità";
var unitCount = "{{ unitsCount }} unità";
var unitPriceWithQuantity = "{{ pricePerUnit }} ciascuno / {{ unitsCount }} unità";
var vatInclusive = "IVA inclusa";
var vatExclusive = "IVA esclusa";
var excludeShipping = "{{ shipping }} esclusa";
var includeShipping = "{{ shipping }} inclusa";
var shipping = "spedizione";
var vatAndShipping = {
	includeVatExcludeShipping: "IVA inclusa, {{ shipping }} esclusa",
	excludeVatIncludeShipping: "IVA esclusa, {{ shipping }} inclusa",
	includeVatIncludeShipping: "IVA inclusa, {{ shipping }} inclusa",
	excludeVatExcludeShipping: "IVA esclusa, {{ shipping }} esclusa"
};
var priceSummary = "Riepilogo prezzi";
var priceSummaryInfoIcon = "Icona informativa Riepilogo prezzi";
var priceSummaryModal = "Finestra modale Riepilogo prezzi";
var priceSummaryCloseModal = "Chiudi finestra modale Riepilogo prezzi";
var priceSummaryTermsAndConditions = "*Per ciascun ordine, viene creata una schermata o un tampone unico e le attrezzature vengono regolate per stampare il tuo design. ";
var priceSummaryBasePrice = "Prezzo di base";
var priceSummarySetupFee = "Costi di preparazione*";
var priceSummarySubtotal = "Totale parziale";
var differentialPrice = {
	included: "Inclusa",
	forUnits: "{{ differentialPrice }} per {{ quantity }} unità",
	forUnit: "{{ differentialPrice }} per {{ quantity }} unità"
};
var priceFrom = "A partire da {{ price }}";
var priceFromEach = "Da {{ price }} ciascuno";
var volumeDiscount = "{{volumeDiscount}}% sconto su quantità";
var volumeDiscountPlusSale = "{{volumeDiscount}}% sconto su quantità + offerta";
var rangePrice = "{{xx}} - {{yy}}";
var unitRangePrice = "{{rangePrice}} al pezzo";
var originalPrice = "prezzo originale:";
var salePrice = "prezzo di vendita attuale:";
var setupFee = "Si applicano i costi di preparazione di {{ setupFee }}";
var noSetupFee = "Nessun costo di preparazione";
var vatAndSetupFee = {
	noVatInclSetup: "Costo di preparazione ({{ setupFee }}) incl.",
	inclVatAndSetup: "Costo di preparazione e IVA ({{ setupFee }}) incl.",
	exclVatInclSetup: "Costo di preparazione ({{ setupFee }}) incl., IVA escl.",
	inclVatSetupInclShipping: "Costo di preparazione ({{ setupFee }}) e IVA incl., {{ shipping }} incl.",
	inclVatSetupExclShipping: "Costo di preparazione ({{ setupFee }}) e IVA incl., {{ shipping }} escl.",
	exclVatSetupInclShipping: "Costo di preparazione ({{ setupFee }}) incl., IVA escl., {{ shipping }} incl.",
	exclVatSetupExclShipping: "Costo di preparazione ({{ setupFee }}) incl., IVA e {{ shipping }} escl."
};
var priceFor = "{{ quantity }} per {{ price }}";
var itit = {
	unitPrice: unitPrice,
	unitsCount: unitsCount,
	unitCount: unitCount,
	unitPriceWithQuantity: unitPriceWithQuantity,
	vatInclusive: vatInclusive,
	vatExclusive: vatExclusive,
	excludeShipping: excludeShipping,
	includeShipping: includeShipping,
	shipping: shipping,
	vatAndShipping: vatAndShipping,
	priceSummary: priceSummary,
	priceSummaryInfoIcon: priceSummaryInfoIcon,
	priceSummaryModal: priceSummaryModal,
	priceSummaryCloseModal: priceSummaryCloseModal,
	priceSummaryTermsAndConditions: priceSummaryTermsAndConditions,
	priceSummaryBasePrice: priceSummaryBasePrice,
	priceSummarySetupFee: priceSummarySetupFee,
	priceSummarySubtotal: priceSummarySubtotal,
	differentialPrice: differentialPrice,
	priceFrom: priceFrom,
	priceFromEach: priceFromEach,
	volumeDiscount: volumeDiscount,
	volumeDiscountPlusSale: volumeDiscountPlusSale,
	rangePrice: rangePrice,
	unitRangePrice: unitRangePrice,
	originalPrice: originalPrice,
	salePrice: salePrice,
	setupFee: setupFee,
	noSetupFee: noSetupFee,
	vatAndSetupFee: vatAndSetupFee,
	priceFor: priceFor
};

export { itit as default, differentialPrice, excludeShipping, includeShipping, noSetupFee, originalPrice, priceFor, priceFrom, priceFromEach, priceSummary, priceSummaryBasePrice, priceSummaryCloseModal, priceSummaryInfoIcon, priceSummaryModal, priceSummarySetupFee, priceSummarySubtotal, priceSummaryTermsAndConditions, rangePrice, salePrice, setupFee, shipping, unitCount, unitPrice, unitPriceWithQuantity, unitRangePrice, unitsCount, vatAndSetupFee, vatAndShipping, vatExclusive, vatInclusive, volumeDiscount, volumeDiscountPlusSale };
